import { PropsWithChildren } from "react"
import cn from "classnames"

import { ProgressBar } from "modules/NewClientSurvey/components/index"
import style from "modules/NewClientSurvey/components/QuestionnairePage/style.module.scss"
import { Img, Button, Text, Box } from "ui-kit/components-branded/index"

interface Props {
    className?: string
    title?: string
    currentStep: number
    maxStep: number
    showButton?: boolean
    disabledButton?: boolean
    info?: string
    isValidAnswer?: boolean
    onClickButton?: () => void
}

export function QuestionnairePage({
    className,
    title,
    currentStep,
    maxStep,
    showButton,
    disabledButton,
    info,
    isValidAnswer,
    onClickButton,
    children,
}: PropsWithChildren<Props>) {
    return (
        <div className={style.container}>
            <div className={style.contentWrapper}>
                <Box className={cn(style.content, className)}>
                    <ProgressBar step={currentStep} count={maxStep} />
                    <div>
                        {title && (
                            <div
                                className={cn(style.title, {
                                    [style.isInfo]: info,
                                })}
                            >
                                {title}
                            </div>
                        )}
                        {info && <Text className={style.info}>{info}</Text>}
                    </div>
                    {children}
                    {showButton && (
                        <div className={style.buttonWrapper}>
                            <Button
                                color="primary"
                                onClick={onClickButton}
                                disabled={disabledButton}
                                className={style.button}
                            >
                                Продолжить
                            </Button>
                            {!isValidAnswer && info && (
                                <Text className={style.buttonError} isSecondary>
                                    {info}
                                </Text>
                            )}
                        </div>
                    )}
                </Box>
                <div className={style.emoji}>
                    <Img src="regular-emoji.gif" />
                </div>
            </div>
        </div>
    )
}
